import { IMongoDocument } from "utils/types"
import { ElixirModel } from "../elixirsAPI/values"
import { INewBalance } from "../balanceAPI/balance.types"

export const enum AUCTION_SOCKETS {
  AUCTION_UPDATED = "auction:auction-updated",
  SUBMIT_BID = "auction:submit-bid",
  ITEM_SOLD = "auction:item-sold"
}

export enum AUCTION_STATUS {
  PENDING = "pending",
  ACTIVE_WARMUP = "active-warmup", // <12h
  ACTIVE_HEAT_UP = "active-heatup", // <6h
  ACTIVE_SHOWDOWN = "active-showdown", // <3h
  ACTIVE_LAST_CALL = "active-last-call", // <1h
  ACTIVE_FINAL_BUZZER = "active-final-buzzer", // <30m
  ENDS = "ends", // <=15 min
  FINISHED = "finished"
}

export const auctionActiveStatuses = [
  AUCTION_STATUS.ACTIVE_WARMUP,
  AUCTION_STATUS.ACTIVE_HEAT_UP,
  AUCTION_STATUS.ACTIVE_SHOWDOWN,
  AUCTION_STATUS.ACTIVE_LAST_CALL,
  AUCTION_STATUS.ACTIVE_FINAL_BUZZER,
  AUCTION_STATUS.ENDS
]

export enum AUCTION_CURRENCY {
  LABR = "labr",
  GOLD = "gold"
}

export interface IAuctionCurrency {
  gold: number
  labr: number
}

export interface IAuctionBid {
  _id: string
  bidAmountInGoldEquivalent: number
  bidAmount: number
  currency: AUCTION_CURRENCY
}

export interface IAuction extends IMongoDocument {
  refundPercentage: IAuctionCurrency
  status: AUCTION_STATUS
  __endAt?: string
}

export interface IAuctionLotItemData extends IMongoDocument {
  type: string
  imgSrc: string
  level: number
  description: string
  bonus: number
  durationMs: number
  isPremium: boolean
}

export enum IAuctionLotItemType {
  ELIXIR = "elixir"
}

export interface IAuctionLotItem extends IMongoDocument {
  auctionId: string
  item: IAuctionLotItemData | null
  itemModel: ElixirModel.PREMIUM | ElixirModel.DARK
  itemType: IAuctionLotItemType
  lotId: string
}

export interface IAuctionLot extends IMongoDocument {
  auctionId: string
  availableCountToPurchaseNow: number
  currentPrice: IAuctionCurrency
  initialAvailableCountToPurchaseNow: number
  lastBid: IAuctionBid | null
  lastBidder: string | null
  name: string
  priceStep: IAuctionCurrency
  priceToPurchaseNow: IAuctionCurrency
}

export interface IAuctionCurrentLot {
  lot: IAuctionLot
  items: IAuctionLotItem[]
}

export interface IAuctionCurrent {
  auction: IAuction | null
  lots: IAuctionCurrentLot[]
}

export interface IAuctionSubmitBidEvent extends IMongoDocument {
  auctionId: string
  lotId: string
  amountInGoldEquivalent: number
  amountInLabrEquivalent: number
  amount: number
  currency: AUCTION_CURRENCY
  sentReward: boolean
}

export interface IAuctionItemSoldEvent extends IMongoDocument {
  auctionId: string
  lotId: string
  availableCountToPurchaseNow: number
}

export interface IAuctionUpdatedEvent extends IMongoDocument {
  newStatus: AUCTION_STATUS
}

export interface IAuctionSubmitBidDto {
  lotId: string
  value: number
  currency: AUCTION_CURRENCY
  userId: string
}

export interface IAuctionSubmitBidRes extends IMongoDocument {
  amount: number
  amountInGoldEquivalent: number
  amountInLabrEquivalent: number
  auctionId: string
  currency: AUCTION_CURRENCY
  lotId: string
  sentReward: boolean
  userId: string
}

export interface IAuctionBuyNowDto {
  lotId: string
  currency: AUCTION_CURRENCY
  userId: string
}

export interface IAuctionBuyNowRes {
  items: IAuctionLotItem[]
  newBalance: INewBalance
}

export interface IAuctionUserStatsRes {
  totalBids: number
  totalWins: number
}
